// ligfrontend/src/components/Lig/NoteCard.jsx
import React, { useState } from "react";
import InlineEditor from "../common/InlineEditor";
import DatePicker from "../common/DatePicker";
import PhotoUpload from "../common/PhotoUpload";
import "./NoteCard.css";

const NoteCard = ({
  note,
  onUpdateMessage,
  onUpdateDate,
  onUpdatePhoto,
  onDelete,
}) => {
  const [isEditingPhoto, setIsEditingPhoto] = useState(false);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handlePhotoSelect = async (file) => {
    await onUpdatePhoto(note._id, file);
    setIsEditingPhoto(false);
  };

  const handlePhotoRemove = async () => {
    await onUpdatePhoto(note._id, null);
    setIsEditingPhoto(false);
  };

  return (
    <div className="note-card">
      <div className="note-header">
        <DatePicker
          value={note.date}
          onChange={(newDate) => onUpdateDate(note._id, newDate)}
        />
        <span className="note-time">{formatTime(note.date)}</span>
      </div>

      {note.image && !isEditingPhoto && (
        <div className="note-photo-container">
          <img src={note.image} alt="Note" className="note-photo" />
          <button
            className="btn-edit-photo"
            onClick={() => setIsEditingPhoto(true)}
          >
            ✏️ Change Photo
          </button>
        </div>
      )}

      {(!note.image || isEditingPhoto) && (
        <div className="note-photo-upload">
          <PhotoUpload
            currentPhoto={note.image}
            onPhotoSelect={handlePhotoSelect}
            onPhotoRemove={handlePhotoRemove}
          />
          {isEditingPhoto && (
            <button
              className="btn-cancel-photo-edit"
              onClick={() => setIsEditingPhoto(false)}
            >
              Cancel
            </button>
          )}
        </div>
      )}

      <div className="note-content">
        <div className="quote-mark">❝</div>
        <InlineEditor
          value={note.msg}
          onSave={(newValue) => onUpdateMessage(note._id, newValue)}
          onDelete={() => onDelete(note._id)}
          multiline={true}
          showQuotes={false}
        />
      </div>
    </div>
  );
};

export default NoteCard;
